import { useEffect, useId, useRef } from "react";
import { RiCloseFill } from "react-icons/ri";

const Modal = ({ open, children, onClose, title, className = "w-[90vw] max-w-2xl" }) => {
  const dialogRef = useRef(null);
  const titleId = useId();

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }

    if (open) {
      dialog.showModal();
    } else {
      dialog.close();
    }
  }, [open]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }
    // Escape triggers the native "close" event without going through onClose, leaving parent state stale.
    dialog.addEventListener("close", onClose);
    return () => dialog.removeEventListener("close", onClose);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === dialogRef.current) {
      onClose();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y-x/click-events-have-key-events, jsx-a11y-x/no-noninteractive-element-interactions -- Le clic ne concerne que l'arrière-plan du dialogue, qui dispose aussi d'un bouton de fermeture au clavier.
    <dialog
      ref={dialogRef}
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={handleBackdropClick}
      className="fixed inset-0 m-auto max-h-[90vh] max-w-[90vw] overflow-visible bg-transparent p-0 backdrop:bg-black/60"
    >
      <div className={`${className} relative max-h-[90vh] overflow-y-auto bg-white`}>
        <div className="flex justify-end px-8 py-4">
          <button type="button" aria-controls="modal" className="tertiary-btn" onClick={onClose} aria-label="Fermer">
            <span className="leading-none" aria-hidden="true">
              Fermer
            </span>
            <RiCloseFill className="ml-2 inline text-sm" aria-hidden="true" />
          </button>
        </div>
        <div className="mb-16 flex flex-col gap-4 px-8">
          <h2 id={titleId} className="text-2xl font-bold">
            {title}
          </h2>
          {children}
        </div>
      </div>
    </dialog>
  );
};
export default Modal;
